// Lib
import React from 'react';
import styled from 'styled-components';
import { Box, Flex } from 'rebass';

// Hooks
import useModal from 'hooks/useModal';

// Components
import ShareLinkModal from './ShareLinkModal';
import EditCandidatesNotes from './EditCandidatesNotes';
import ArchivedCandidates from './ArchivedCandidates';
import RejectReason from './RejectReason';
import NotificationModal from './NotificationModal';
import AttachFile from './AttachFile';
import SearchByLocation from './SearchByLocation';
import SendMessages from './SendMessages';
import SignUpComplete from './SignUpComplete';
import Confirm from './Confirm';
import PDFPreviewModal from './PDFPreviewModal';

const Wrapper = styled(Flex)<any>`
  display: ${(props: any) => (props.isOpen ? 'flex' : 'none')};
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 15;
`;

const Modal: React.FC = () => {
  const { closeModalHandler, title } = useModal();

  return (
    <Box>
      <Wrapper isOpen={!!title}>
        {(() => {
          switch (title) {
            case 'shareLink':
              return <ShareLinkModal closeModalHandler={closeModalHandler} />;
            case 'editNotes':
              return <EditCandidatesNotes closeModalHandler={closeModalHandler} />;
            case 'archivedCandidates':
              return <ArchivedCandidates closeModalHandler={closeModalHandler} />;
            case 'rejectReason':
              return <RejectReason closeModalHandler={closeModalHandler} />;
            case 'notification':
              return <NotificationModal closeModalHandler={closeModalHandler} />;
            case 'attachFile':
              return <AttachFile closeModalHandler={closeModalHandler} />;
            case 'searchByLocation':
              return <SearchByLocation closeModalHandler={closeModalHandler} />;
            case 'sendMessages':
              return <SendMessages closeModalHandler={closeModalHandler} />;
            case 'signUpComplete':
              return <SignUpComplete closeModalHandler={closeModalHandler} />;
            case 'confirm':
              return <Confirm closeModalHandler={closeModalHandler} />;
            case 'PDFPreview':
              return <PDFPreviewModal closeModalHandler={closeModalHandler} />;
            default:
              return null;
          }
        })()}
      </Wrapper>
    </Box>
  );
};

export default Modal;
